import clsx from 'clsx'
import React from 'react'
import type { BlogPostTagResult } from '../../data/BlogPostTagFragment'
import type { BodyTagResult } from '../../data/BodyTagFragment'
import type { ItemSubCategoryPreviewResult } from '../../data/ItemSubCategoryFragment'
import style from '../../styles/Tag.module.sass'

type TagColor =
	| 'positiveGreen'
	| 'negativeRed'
	| 'green'
	| 'yellow'
	| 'brown'
	| 'blue'
	| 'olive'
	| 'pink'
	| 'orange'
	| 'greenLight'
	| 'grey'
	| 'greyMedium'
	| 'red'

type TagProps = {
	tag?: ItemSubCategoryPreviewResult | BodyTagResult | BlogPostTagResult
	isLarger?: boolean
	color?: TagColor | string
	label: string
	isFilterTag?: boolean
}

export const Tag = React.memo(function Tag(props: TagProps) {
	return props.tag ? (
		<div
			style={{
				backgroundColor: `${props.color}B2`, // B2 suffix for 70 % opacity
			}}
			className={clsx(style.tag, props.isLarger && style.tag_larger)}
		>
			{props.tag.name}
		</div>
	) : (
		<div className={clsx(style.tag, style['tag_' + props.color], props.isLarger && style.tag_larger)}>
			{props.label}
		</div>
	)
})
